export const SURVEY_CATEGORY_CODE = 232;
